import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "category-item" }
const _hoisted_2 = { class: "category-item-foreground-wrapper" }
const _hoisted_3 = { class: "category-item-foreground" }
const _hoisted_4 = { class: "category-item-intro font-24" }
const _hoisted_5 = { class: "category-item-title PingFangSC-Medium" }
const _hoisted_6 = { class: "category-item-button-icon flex-center" }
const _hoisted_7 = ["src"]

import useAppear from '@/hooks/use-appear'
import { namedImages } from '@/store'

// eslint-disable-next-line no-undef

export default /*@__PURE__*/_defineComponent({
  __name: 'CategoryItem',
  props: {
  cover: {
    type: String,
    required: true
  },
  category: {
    type: String,
    required: true
  }
},
  emits: ['tap'],
  setup(__props, { emit: __emit }) {

const emit = __emit
// eslint-disable-next-line no-undef


const { target, coverVisible } = useAppear()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "target",
      ref: target,
      class: "category-item-cover"
    }, [
      _withDirectives(_createElementVNode("div", {
        class: "category-item-cover-image",
        style: _normalizeStyle(`background-image: url(${__props.cover})`)
      }, null, 4), [
        [_vShow, _unref(coverVisible)]
      ])
    ], 512),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(__props.category), 1)
        ]),
        _createElementVNode("div", {
          class: "category-item-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('tap')))
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              src: _unref(namedImages).icon_try_on_black
            }, null, 8, _hoisted_7)
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "category-item-button-label PingFangSC-Regular font-14" }, " 虚拟体验 ", -1))
        ])
      ])
    ])
  ]))
}
}

})